import Immutable, { Record, List } from 'immutable';
import ActivityItem from './ActivityItem';

const ActivityRecord = Record({
  lessonNumber: undefined,
  cicActivityId: undefined,
  cicActivityName: undefined,
  orderingSequence: undefined,
  cicActivityItems: new List(),
});

class Activity extends ActivityRecord {}

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'cicActivityName':
      return [key, `${val}`];
    case 'cicActivityItems':
      return [key, new List(val.map(ActivityItem.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

Activity.create = (data) =>
  new Activity(data).mapEntries(reviver);

export default Activity;



// WEBPACK FOOTER //
// ./data/CoveredInClass/Activity/model.js